// Central registry of brand assets (client-provided)
export const ASSETS = {
  logoIcon: "https://customer-assets-jt897jd0.emergentagent.net/job_wutn-portal/artifacts/33uy8qoi_WUTN%20-%20LOGO%20Square%20-%20BLK%20BG.png",
  logoFull: "https://customer-assets-jt897jd0.emergentagent.net/job_wutn-portal/artifacts/gh8xoqe6_WUTN%20-%20Wake-Up%20The%20Nation%20LOGO%20SQUARE.png",
  banner: "https://customer-assets-jt897jd0.emergentagent.net/job_wutn-portal/artifacts/2862sp9p_WUTN%20-%20Wake-Up%20The%20Nation%20YOUTUBE%20BANNER%20%281%29.webp",
  // Founder — Kerby Stivene
  founderPortrait: "https://customer-assets-jt897jd0.emergentagent.net/job_wutn-portal/artifacts/9dcgdqi1_Kerby%20Portrait%20with%20BG.webp",
  founderWhiteWide: "https://customer-assets-jt897jd0.emergentagent.net/job_wutn-portal/artifacts/arigg2yi_SLEPSummerProgramAug2025JMP-49.webp",
  founderWhiteSquare: "https://customer-assets-jt897jd0.emergentagent.net/job_wutn-portal/artifacts/35kpmpho_SLEPSummerProgramAug2025JMP-49%20-%20Square.webp",
  // Preaching / cinematic
  preachingStage: "https://customer-assets-jt897jd0.emergentagent.net/job_wutn-portal/artifacts/o2sjjoa7_DSC_5877-2.webp",
  preachingPodium: "https://customer-assets-jt897jd0.emergentagent.net/job_wutn-portal/artifacts/mqyp09au_468407187_122150436674319022_858587290510641496_n%20%281%29.jpg",
  // Community
  groupAdults: "https://customer-assets-jt897jd0.emergentagent.net/job_wutn-portal/artifacts/18mxqiiv_529260022_10171729816340018_233702992629629680_n.jpg",
  groupYouth: "https://customer-assets-jt897jd0.emergentagent.net/job_wutn-portal/artifacts/ptp3bl5d_516746948_10171729816345018_2242913636317727811_n.jpg",
  // Preaching at event — "Next Bold Step" (portrait)
  preachingEvent1: "https://customer-assets-jt897jd0.emergentagent.net/job_wutn-portal/artifacts/zr2b2pml_received_1084996936409277.webp",
  preachingEvent2: "https://customer-assets-jt897jd0.emergentagent.net/job_wutn-portal/artifacts/vunjw04t_received_716297201325766.webp",
};

export const SITE = {
  name: "Wake-Up The Nation",
  short: "WUTN Ministries",
  founder: "Kerby Stivene",
  tagline: "Awaken the Church. Disciple Believers. Share the Gospel.",
  location: "Sundridge, ON, Canada",
  email: "wuministry@gmail.com",
  youtube: "https://www.youtube.com/@WakeUpTheNation",
};
